import { call, put, takeLatest } from "redux-saga/effects";

import {
  GET_GENERIC_MESSAGE_LIST,
  SAVE_GENERIC_MESSAGE_MASTER,
  EDIT_GENERIC_MESSAGE,
  UPDATE_GENERIC_MESSAGE,
  DELETE_GENERIC_MESSAGE,
} from "./actionType";

import {
  getGenericMessageListSuccess,
  saveGenericMessageSuccess,
  editGenericMessageSuccess,
  updateGenericMessageSuccess,
  deleteGenericMessageSuccess,
  GenericMessageErrorAction,
} from "./action";

import {
  Generic_Message_Get_API,
  Generic_Message_Post_API,
  Generic_Message_Edit_API,
  Generic_Message_Update_API,
  Generic_Message_Delete_API,
  Fetch_Generic_Message_API,
} from "../../../helpers/backend_helper";


// 🔹 Save
function* save_Generic_Message_GenFun({ config }) {
  try {
    const response = yield call(Generic_Message_Post_API, config);
    yield put(saveGenericMessageSuccess(response));
  } catch (error) {
    yield put(GenericMessageErrorAction());
  }
}


// 🔹 Get List
function* Get_Generic_Message_List_GenFun({ config }) {
  try {
    const response = yield call(Fetch_Generic_Message_API, config);

    const newList = response.Data.map((i) => {

      const isExpired = i.ValidTo ? new Date(i.ValidTo).getTime() < Date.now() : false;

      i.isEditButtonDisabled = isExpired;
      i.forceDeleteHide = isExpired;

      return i;
    });

    yield put(getGenericMessageListSuccess(newList));

  } catch (error) {
    yield put(GenericMessageErrorAction());
  }
}


// 🔹 Edit
function* Edit_Generic_Message_GenFun({ config }) {
  const { btnmode } = config;
  try {
    const response = yield call(Generic_Message_Edit_API, config);
    response.pageMode = btnmode;
    yield put(editGenericMessageSuccess(response));
  } catch (error) {
    yield put(GenericMessageErrorAction());
  }
}

// 🔹 Update
function* Update_Generic_Message_GenFun({ config }) {
  try {
    const response = yield call(Generic_Message_Update_API, config);
    yield put(updateGenericMessageSuccess(response));
  } catch (error) {
    yield put(GenericMessageErrorAction());
  }
}

// 🔹 Delete
function* Delete_Generic_Message_GenFun({ config }) {
  try {
    const { deleteId } = config;

    const response = yield call(Generic_Message_Delete_API, { deleteId });

    yield put(deleteGenericMessageSuccess(response));
  } catch (error) {
    yield put(GenericMessageErrorAction());
  }
}


// 🔹 Root Saga
function* GenericMessageSaga() {
  yield takeLatest(SAVE_GENERIC_MESSAGE_MASTER, save_Generic_Message_GenFun);
  yield takeLatest(GET_GENERIC_MESSAGE_LIST, Get_Generic_Message_List_GenFun);
  yield takeLatest(EDIT_GENERIC_MESSAGE, Edit_Generic_Message_GenFun);
  yield takeLatest(UPDATE_GENERIC_MESSAGE, Update_Generic_Message_GenFun);
  yield takeLatest(DELETE_GENERIC_MESSAGE, Delete_Generic_Message_GenFun);
}

export default GenericMessageSaga;
